import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { PermissionsDirective } from './permissions/permissions.directive';
import { ResourceLanguageDirective } from './resource-language/resource-language.directive';
import { FocusOnInitDirective } from './focus-on-init/focus-on-init.directive';
import { FocusAutosaveDirective } from './focus-autosave/focus-autosave.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PermissionsDirective,
        ResourceLanguageDirective,
        FocusOnInitDirective,
        FocusAutosaveDirective
    ],
    exports: [
        PermissionsDirective,
        ResourceLanguageDirective,
        FocusOnInitDirective,
        FocusAutosaveDirective
    ]
})
export class PaetepDirectiveModule { }